import {HttpSvcFactory} from './HttpSvc';

export type State = 'studio-following' | 'studio-followers';

export type FollowersSvcFactory = new(sameUser: boolean, state: State, updateFollowingsOnStart?: boolean) => FollowersSvc;

export class FollowersSvc {
    $rootScope: ng.IRootScopeService;
    $location: ng.ILocationService;
    $stateParams: any;
    $filter: ng.IFilterService;
    HttpSvc: HttpSvcFactory;

    busy = false;

    following: Array<anm.User> = [];
    myFollowing: Array<anm.User> = [];

    constructor(private sameUser: boolean,
                private state: State,
                private updateFollowingsOnStart = true) {
        if (state !== 'studio-following' && state !== 'studio-followers') {
            throw new Error('state should be either "following" or "followers". Found ' + JSON.stringify(state));
        }

        if (this.$location.search().startFollowing && !options.user.anonymous) {
            this.$location.url(this.$location.path()).replace();
            this.follow({username: this.$stateParams.username as string} as anm.User);
        }
        if (updateFollowingsOnStart) {
            this.updateFollowing(this.$stateParams.username);
        } else {
            this.updateMyFollowing();
        }
    }

    updateFollowing(username: string) {
        this.busy = true;
        this.updateMyFollowing();
        if (!this.sameUser || this.state === 'studio-followers') {
            this.updateFollowings(username, this.state).then(data => {
                if (angular.isArray(data)) this.following = data;
                this.busy = false;
                this.$rootScope.$emit('$following:loaded');
            });
        }
    };

    updateMyFollowing() {
        return this.updateFollowings(this.$rootScope.user.username, 'studio-following').then(data => {
            this.myFollowing = data;
            if (this.sameUser && this.state === 'studio-following') {
                this.following = data;
                this.busy = false;
            }
        });
    };

    isFollowing(user: anm.User) {
        return _.some(this.myFollowing, {username: user.username});
    };

    follow(user: anm.User) {
        this.baseRelationship(user.username).securePost().then(() => {
            this.myFollowing.push(user);
            user.followers += 1;
        });
    };

    unfollow(user: anm.User) {
        this.baseRelationship(user.username).secureDelete().then(() => {
            this.myFollowing = _.reject(this.myFollowing, {username: user.username});
            user.followers -= 1;
        });
    };

    private baseRelationship = (username: string) =>
        this.HttpSvc('relationships', this.$filter('encodeUsername')(username));


    private updateFollowings(username: string, state: State): ng.IPromise<Array<anm.User>> {
        return this.baseRelationship(username)
            .chain(state.replace('studio-', ''))
            .get()
            .catch<any>(() => this.busy = false)
            .then(r => r.data);
    };
}

function FollowersSvcFactory($rootScope: ng.IRootScopeService,
                             $location: ng.ILocationService,
                             $stateParams: any,
                             $filter: ng.IFilterService,
                             HttpSvc: HttpSvcFactory) {
    _.extend(FollowersSvc.prototype, {
        $rootScope, $location, $stateParams, $filter, HttpSvc,
    });
    return FollowersSvc;
}

angular.module('animatronApp.profileProject').service('FollowersSvc', FollowersSvcFactory);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/FollowersSvc.ts